<template>
  <div class="home">
    <h2>网点资料采集现场</h2>
    <div class="content">
      <!--      <van-icon color="#1296db" float="left" name="volume-o" size="24px"/>
            <input
              v-model="message"
              class="ipt"
              placeholder="当前网点还未录入，是否协助众敏录入？"
              readonly
              type="text"
            />-->
      <van-notice-bar :text="message" background="#ecf9ff" color="#1989fa" left-icon="volume-o" scrollable/>
      <audio id="materialaudio" ref="player" preload="auto" src="" style="display: none; height: 0;">
      </audio>
    </div>

    <!-- 网点内容采集 -->
    <div class="vng">
      <!--      <van-cell-group>
              <van-field
                v-model="material.userAccount"
                label="上报人员"
                placeholder="请输入上报人员名称"
              />
            </van-cell-group>-->
      <van-grid :column-num="3" :gutter="10" square>
        <van-grid-item
          v-for="(item, id) in materialList"
          :key="id"
          class="van-grid"
          @click="handleClick(item)"
        >
          <img
            v-if="['address', 'picAndDesc'].includes(item.type) && item.status"
            :src="base64ToImgSrc(item.content.pic[0])"
          />
          <!--
              :class="
            getImgWidthAndHeight(item.content.pic[0]) > 1 ? 'w-100' : 'h-100'
          " -->
          <span v-else>{{ item.text }}</span>

        </van-grid-item>
      </van-grid>
      <van-button size="large" type="primary" @click="submit">上传</van-button>
    </div>
    <div class="button_container">
      <button v-show="show" class="button pass" @click="passMaterial(1)">通过
      </button>
      <button v-show="show" class="button reject" @click="passMaterial(2)">拒绝
      </button>
      <button v-show="show" class="button send" @click="toUrl">发消息
      </button>
    </div>
    <uploadPic ref="uploadPic" @configPic="configPicData"/>
    <uploadAddress ref="uploadAddress" @configAddress="configAddressData"/>
  </div>
</template>

<script>
import {getCosTempToken, getTTSToken, uploadPosApplyDetail} from "../api";
import uploadPic from "../components/material_upload/material_uploadPic.vue";
import uploadAddress from "../components/material_upload/material_address_dialog.vue";
import {createUpPosImgName, uploadImage} from "../util/material_uploadImage";
import wx from 'weixin-jsapi';
// import {startWork, stopWork} from "../util/mqttConnect.js";
import Vue from 'vue';
import {Toast} from 'vant';
import Axios from "axios";
import {v4 as uuidv4} from 'uuid';

Vue.use(Toast);
const mqtt = require("mqtt");
const mqttUrl = "wss://mqtt.nationaiot.com/mqtt"
const mqttOptions = {
  connectTimeout: 3000,
  clientId: 'omc-material-collection-msg',
  username: 'ccnet',
  password: 'ccnet0901',
  clean: false,
}
var mqttClient = null


export default {
  components: {
    uploadPic,
    uploadAddress,
  },
  created() {
    if (this.$route.params.object) {
      this.startWork();
      this.show = true;
    } else {
      console.log('未携带参数');
    }
    this.queryMaterial();
    this.getCos("apply");
    this.getTTSToken();
    this.configWxForAutoPlay();
    // this.getImgWidthAndHeight()
  },
  destroyed() {
    this.stopWork()
  },

  data() {
    return {
      wxConfigObj: {},
      show: false,   //管理员审核时显示此按钮
      tts_token: null, //baidu语音播报的token
      tts_url: null, //百度语音播报的url
      //参数列表
      material: {
        id: '',                                              //新增的时候自动生成
        status: 0, //  网点状态 (待审核)                                1非空
        modTime: "", // 采集时间                                 1非空
        userAccount: sessionStorage.getItem('openid'), //上报人员的openId
        frontUrl: "", //网点门牌正视图
        sideUrl: "", // 网点门牌侧视图
        offsideUrl: "", //网点门牌右视图
        behindUrl: "", // 网点门牌后视图
        downUrl: "", //网点门牌俯视图
        aroundUrl: "", //网点周边环境视频
        openingHoursUrl: "", //网点营业时间
        telephoneUrl: "", // 网点联系方式
        priceUrl: "", //网点服务价格表
        ruleUrl: "", //网点免责条款
        guideUrl: "", // 网点服务向导
        synopsisUrl: "", //网点服务介绍视频
        addressUrl: "", // 网点地理位置  ----------------非空
        logonQrcodeUrl: "", // 网点自主服务注册二维码
        startQrcodeUrl: "", // 网点自助服务启动二维码
        longitude: "", //经度
        latitude: "", //维度
        frontText: "", //正视图文字描述
        sideText: "", //左视图文字描述
        offsideText: "", //右视图文字描述
        behindText: "", //后视图文字描述
        downText: "", //俯视图文字描述
        aroundText: "", //周围环境文字描述
        openingHoursText: "", //网点营业时间描述
        telephoneText: "", //网点联系方式文字描述
        priceText: "", //网点价格文字描述
        ruleText: "", //网点免责条款文字描述
        guideText: "", //网点服务向导文字描述
        synopsisText: "", //网点服务介绍视频文字描述synopsis
        addressText: "", //网点地理位置文字描述-----------非空
        logonQrcodeText: "", //网点自助服务注册文字描述
        startQrcodeText: "", //网点自助服务启动文字描述
      },
      materialList: [
        {
          id: "1",
          text: "网点门牌正视图",
          status: false,
          type: "picAndDesc",
          name: "front",
          content: {
            pic: [],
            desc: "",
            url: [],
          },
        },
        {
          id: "2",
          text: "网点门牌左视图",
          status: false,
          type: "picAndDesc",
          name: "side",
          content: {
            pic: [],
            desc: "",
            url: [],
          },
        },
        {
          id: "3",
          text: "网点门牌右视图",
          status: false,
          type: "picAndDesc",
          name: "offside",
          content: {
            pic: [],
            desc: "",
            url: [],
          },
        },
        {
          id: "4",
          text: "网点门牌后视图",
          status: false,
          type: "picAndDesc",
          name: "behind",
          content: {
            pic: [],
            desc: "",
            url: [],
          },
        },
        {
          id: "5",
          text: "网点门牌俯视视图",
          status: false,
          type: "picAndDesc",
          name: "down",
          content: {
            pic: [],
            desc: "",
            url: [],
          },
        },
        {
          id: "6",
          text: "网点门牌周边环境图",
          status: false,
          type: "picAndDesc",
          name: "around",
          content: {
            pic: [],
            desc: "",
            url: [],
          },
        },
        {
          id: "7",
          status: false,
          text: "网点营业时间",
          type: "picAndDesc",
          name: "opening_hours",
          content: {
            pic: [],
            desc: "",
            url: [],
          },
        },
        {
          id: "8",
          status: false,
          text: "网点联系方式",
          type: "picAndDesc",
          name: "telephone",
          content: {
            pic: [],
            desc: "",
            url: [],
          },
        },
        {
          id: "9",
          status: false,
          text: "网点服务价目表",
          type: "picAndDesc",
          name: "price",
          content: {
            pic: [],
            desc: "",
            url: [],
          },
        },
        {
          id: "10",
          status: false,
          text: "网点免责条款",
          type: "picAndDesc",
          name: "rule",
          content: {
            pic: [],
            desc: "",
            url: [],
          },
        },
        {
          id: "11",
          status: false,
          text: "网点服务向导",
          type: "picAndDesc",
          name: "guide",
          content: {
            pic: [],
            desc: "",
            url: [],
          },
        },
        {
          id: "12",
          status: false,
          text: "网点服务视频介绍",
          type: "picAndDesc",
          name: "synopsis",
          content: {
            pic: [],
            desc: "",
            url: [],
          },
        },
        //输入地址获取到当前的地理位置
        {
          id: "13",
          status: false,
          text: "网点地理位置",
          type: "address",
          name: "lon",
          content: {
            pic: [],
            desc: "",
            url: [],
            longitude: "",
            latitude: "",
          },
        },
        {
          id: "14",
          status: false,
          text: "网点自助服务注册二维码",
          type: "picAndDesc",
          name: "logon_qrcode",
          content: {
            pic: [],
            desc: "",
            url: [],
          },
        },
        {
          id: "15",
          status: false,
          text: "网点自助服务启动二维码",
          type: "picAndDesc",
          name: "start_qrcode",
          content: {
            pic: [],
            desc: "",
            url: [],
          },
        },
      ],
      completeness: 0,    //定义初始资料完整度值为0
      message: '当前网点还未录入，是否协助众敏录入？',  //mqtt中订阅者接收的消息
    };
  },

  /*  watch: {
      // currentSong 指当前播放的歌曲
      currentSong() {
        console.log('-------------------------', '播放mqtt的语音')
        this.$refs.player.ondurationchange = () => {
          if (this.isPlaying) {
            this.$refs.player.play()
          } else {
            this.$refs.player.pause()
          }
        }
      },
    },*/

  methods: {
    //网点申报状态已通过的方法，管理员审核过通过后改变它的状态（通过的状态为1，拒绝的状态为2）
    passMaterial(status) {
      if (this.$route.params.object) {
        const id = this.$route.params.object.id;
        this.material.id = id;
        this.material.status = status;
        this.parameter();
        this.getCurrentDate();
        let params = this.material;
        uploadPosApplyDetail(params).then((res) => {
          console.log("返回网点申报已通过的状态", res.data.status);
          //管理员审核通过后，跳转到查询页面
          if (res.data.status == 1) {
            this.$router.push("/material_query");
          }
          //为拒绝状态的时候就可以对采集员进行mqtt信息发送
          if (res.data.status == 2) {
            this.toUrl();
            this.$router.push("/material_sendMsg");
          }
        })
      }
    },

    //mqtt中的接收者方法stopwork跟startwork
    stopWork() {
      if (mqttClient) {
        mqttClient.end();
        mqttClient = null;
      }
    },
    startWork() {
      // 连接
      this.stopWork()
      if (!mqttClient) {
        mqttClient = mqtt.connect(mqttUrl, mqttOptions)
      }
      mqttClient.on('connect', (e) => {
        mqttClient.subscribe(topic, {qos: 2}, (err) => {
          if (!err) {
            console.log("消息订阅成功")
          } else {
            console.log("消息订阅失败", topic, err)
          }
        })
      })
      const topic = `ccnet/down/man/${this.$route.params.object.userAccount}`
      //收到订阅的主题的消息
      mqttClient.on('message', (topic, payload) => {
        console.log("收到来自", topic, "的消息:", payload.toString())
        try {
          /* let message = JSON.parse(payload.toString());
           if (this.message === message.messageData) return;
           if (message.messageId == this.$route.params.object.id) {
             this.message = message.messageData
             alert(`${this.message}`)
           }*/
          this.onMessageArrived(payload);
          console.log(this.message, payload, topic)
        } catch (exp) {
          console.log(exp)
        }
      })

    },

    //将openid传到发消息页面material_sendMsg.vue
    toUrl() {
      this.$router.push({
        name: "material_sendMsg", params: {
          openid: this.$route.params.object.userAccount,
          id: this.$route.params.object.id,
        }
      });
    },

    //查询网点现场资料采集（text，url，userAccount，经纬度）
    queryMaterial() {
      // console.log(this.materialList)
      if (this.$route.params.object) {
        console.log('接收的参数', this.$route.params.object);
        let params = this.$route.params.object;
        this.material.userAccount = params.userAccount;

        this.materialList.forEach((e) => {
          // console.log(e);
          if (e.name === "lon") {
            e.content.desc = params.addressText;
            e.content.latitude = params.latitude;
            e.content.longitude = params.longitude;
            let list = params.addressUrl && JSON.parse(params.addressUrl); //JSON.parse将一个字符串转对象或数组
            // console.log(list);
            e.status = params.addressText || list.length > 0;
            e.content.pic = list;
            e.content.url = list;
            /*e.content.pic.push(...list)
            e.content.url.push(...list);*/
          }
          if (e.name === "front") {
            e.content.desc = params.frontText;
            let list = params.frontUrl && JSON.parse(params.frontUrl);
            e.status = params.frontText || list.length > 0;
            e.content.pic = list;
            e.content.url = list;
          }
          if (e.name === "side") {
            e.content.desc = params.sideText;
            let list = params.sideUrl && JSON.parse(params.sideUrl);
            e.status = params.sideText || list.length > 0;
            e.content.pic = list;
            e.content.url = list;
          }
          if (e.name === "offside") {
            e.content.desc = params.offsideText;
            let list = params.offsideUrl && JSON.parse(params.offsideUrl);
            e.status = params.offsideText || list.length > 0;
            e.content.pic = list;
            e.content.url = list;
          }
          if (e.name === "behind") {
            e.content.desc = params.behindText;
            let list = params.behindUrl && JSON.parse(params.behindUrl);
            e.status = params.behindText || list.length > 0;
            e.content.pic = list;
            e.content.url = list;
          }
          if (e.name === "down") {
            e.content.desc = params.downText;
            let list = params.downUrl && JSON.parse(params.downUrl);
            e.status = params.downText || list.length > 0;
            e.content.pic = list;
            e.content.url = list;
          }
          if (e.name === "around") {
            e.content.desc = params.aroundText;
            let list = params.aroundUrl && JSON.parse(params.aroundUrl);
            e.status = params.aroundText || list.length > 0;
            e.content.pic = list;
            e.content.url = list;
          }
          if (e.name === "opening_hours") {
            e.content.desc = params.openingHoursText;
            let list = params.openingHoursUrl && JSON.parse(params.openingHoursUrl);
            e.status = params.openingHoursText || list.length > 0;
            e.content.pic = list;
            e.content.url = list;
          }
          if (e.name === "telephone") {
            e.content.desc = params.telephoneText;
            let list = params.telephoneUrl && JSON.parse(params.telephoneUrl);
            e.status = params.telephoneText || list.length > 0;
            e.content.pic = list;
            e.content.url = list;
          }
          if (e.name === "price") {
            e.content.desc = params.priceText;
            e.content.desc = params.telephoneText;
            let list = params.priceUrl && JSON.parse(params.priceUrl);
            e.status = params.priceText || list.length > 0;
            e.content.pic = list;
            e.content.url = list;
          }
          if (e.name === "rule") {
            e.content.desc = params.ruleText;
            let list = params.ruleUrl && JSON.parse(params.ruleUrl);
            e.status = params.ruleText || list.length > 0;
            e.content.pic = list;
            e.content.url = list;
          }
          if (e.name === "guide") {
            e.content.desc = params.guideText;
            let list = params.guideUrl && JSON.parse(params.guideUrl);
            e.status = params.guideText || list.length > 0;
            e.content.pic = list;
            e.content.url = list;
          }
          if (e.name === "synopsis") {
            e.content.desc = params.synopsisText;
            let list = params.synopsisUrl && JSON.parse(params.synopsisUrl);
            e.status = params.synopsisText || list.length > 0;
            e.content.pic = list;
            e.content.url = list;
          }
          if (e.name === "logon_qrcode") {
            e.content.desc = params.logonQrcodeText;
            let list = params.logonQrcodeUrl && JSON.parse(params.logonQrcodeUrl);
            e.status = params.logonQrcodeText || list.length > 0;
            e.content.pic = list;
            e.content.url = list;
          }
          if (e.name === "start_qrcode") {
            e.content.desc = params.startQrcodeText;
            let list = params.startQrcodeUrl && JSON.parse(params.startQrcodeUrl);
            e.status = params.startQrcodeText || list.length > 0;
            e.content.pic = list;
            e.content.url = list;
          }
        })
      }
    },


    //获取当前的时间
    getCurrentDate() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = ("0" + (currentDate.getMonth() + 1)).slice(-2);
      const day = ("0" + currentDate.getDate()).slice(-2);
      const hour = currentDate.getHours();
      const minute = currentDate.getMinutes();
      const second = currentDate.getSeconds();
      const date = `${year}-${month}-${day}---${hour}:${minute}:${second}`;
      this.material.modTime = date;
    },

    //获取cos权限
    getCos(path) {
      getCosTempToken(path).then((res) => {
        if (res.data.retcode == 0) {
          let data = res.data.data;
          sessionStorage.setItem(`${path}_cosPath`, data.pathPre);
        }
      });
    },

    //获取baidu语音token权限
    getTTSToken() {
      let that = this;
      getTTSToken().then((res) => {
        console.log('tts_token', res);
        if (res.data.retcode == 0) {
          let data = res.data.data;
          that.tts_token = data.access_token;
        }
      })
    },

    //收到数据事件(通过调用百度的TTSAPI可以播放mqtt传过来的文本信息)
    onMessageArrived(message) {
      let that = this;
      console.log('收到的数据', message)
      try {
        let msg = JSON.parse(message.toString());
        if (msg.hasOwnProperty("messageId") && msg.messageId === that.$route.params.object.id) {
          that.message = msg.messageData;
          let const_tts_url = "https://tsn.baidu.com/text2audio?tex=MSG&tok=TOKEN&cuid=OPENID&ctp=1&lan=zh&aue=3&per=111";
          if (that.tts_token != null) {
            that.tts_url = const_tts_url.replace("MSG", msg.messageData).replace("TOKEN", that.tts_token).replace("OPENID", that.material.userAccount);
            that.playMaterialAudio(that.tts_url, that.message)
          }
        }
      } catch (e) {
        console.log("mqtt catch err.", e);
      }
    },

    //微信公众号或小程序中调用微信提供的API接口
    configWxForAutoPlay() {
      let that = this;
      that.wxConfigObj.jsApiList = ['chooseWXPay', 'getLocation', 'openLocation', 'scanQRCode', 'updateTimelineShareData', 'updateAppMessageShareData'];
      that.wxConfigObj.url = window.location.href.split('#')[0];
      Axios.post('/customer/zmxcl/entry', {
        msgType: 'getJsapiConfig',  //
        ver: '1', //
        msgID: uuidv4(), //
        timestamp: Date.now(), //
        url: that.wxConfigObj.url //
        // 拦截响应
      }).then(response => {
        that.wxConfigObj.data = response.data.wxJsapiConfigRequestInfo;
      })
    },

    playMaterialAudio(aurl, atxt) {
      console.log('-----------------------------------', '语音播放')
      let that = this;
      // 通过config接口注入权限验证配置
      wx.config({
        debug: false,  //开启调试模式，调用所有api的返回值会在客户端alert出来，
        appId: that.wxConfigObj.data.appId, //公众号唯一标识
        timestamp: that.wxConfigObj.data.timestamp, //生成签名的时间戳
        nonceStr: that.wxConfigObj.data.nonceStr, //生成签名的随机串
        signature: that.wxConfigObj.data.signature, //签名
        jsApiList: that.wxConfigObj.jsApiList //需要使用的JS接口列表
      });

      wx.ready(function () {
        let audio = document.getElementById("materialaudio");
        audio.src = aurl;
        that.message = atxt;
        audio.play();
      })
    },


    //显示base64格式的图片
    base64ToImgSrc(file) {
      // console.log(file)
      if (!file) return
      if (typeof file === 'string') {
        return file
      } else if (file.url) {

        return file.url
      } else {
        return file.content;
      }
    },

    // 获取宽高比
    /* getImgWidthAndHeight(file) {
       const base64 = file.content;
       const image = new Image();
       if (typeof file === 'string') {
         image.src = file;

       } else {
         image.src = base64;
       }
       const aspectRatio = image.width / image.height;
       console.log(image);
       console.log(image.width, image.height);
       return aspectRatio;
     },*/


    //点击通过if语句判断type的类型来控制弹窗
    handleClick(item) {
      //网点地理位置
      if (item.type === "address") {
        this.$refs.uploadAddress.show = true;
        this.$refs.uploadAddress.title = item.text;
        this.$refs.uploadAddress.target = {...item};
      } else {
        this.$refs.uploadPic.show = true;
        this.$refs.uploadPic.title = item.text;
        this.$refs.uploadPic.target = {...item};
      }
    },


    async configPicData(id, fileList, message) {
      const urlList = [];
      for (const file of fileList) {
        let imageName = createUpPosImgName();
        let base64 = file.content;
        console.log(file)
        if (typeof file.url === "string") {
          urlList.push(file.url);
        } else if (file.content) {
          try {
            const url = await uploadImage(base64, imageName, "apply");
            urlList.push(url);
          } catch (error) {
            console.error(error);
          }
        }
      }
      console.log(urlList.length);
      this.saveImgUrl(urlList, id, fileList, message);
    },


    //保存图片，文字，内容，及图片地址
    saveImgUrl(urlList, id, fileList, message) {
      console.log('----------------------------', urlList)
      this.materialList = this.materialList.map((item) => {
        if (item.id === id) {
          item.status = true;
          item.content = {
            pic: urlList.map(i => {
              console.log(i)
              return {url: i}
            }),
            // pic: fileList,
            url: urlList,
            desc: message,
          };
        }
        return item;
      });
    },

    //上传地址图片
    /*     configAddressData(id, fileList, message, longitude, latitude) {
          const addressUrlList = [];
          fileList.forEach((file) => {
            console.log(file)
            let imageName = createUpPosImgName();
            let base64 = file.content;
            if (typeof file.url === "string") {
              addressUrlList.push(file.url);

            } else if (file.content) {
              uploadImage(base64, imageName, "apply", (url) => {
                //   this.saveImgUrlAddress(url, id, fileList, message, longitude, latitude);
                addressUrlList.push(url);
              });
            }
          });*/
    async configAddressData(id, fileList, message, longitude, latitude) {
      const addressUrlList = [];

      for (const file of fileList) {
        let imageName = createUpPosImgName();
        let base64 = file.content;
        console.log(file)
        if (typeof file.url === "string") {
          addressUrlList.push(file.url);
        } else if (file.content) {
          try {
            const url = await uploadImage(base64, imageName, "apply");
            addressUrlList.push(url);
          } catch (error) {
            console.error(error);
          }
        }
      }
      console.log(addressUrlList.length);
      this.saveImgUrlAddress(
        addressUrlList,
        id,
        fileList,
        message,
        longitude,
        latitude
      );
    },
    saveImgUrlAddress(
      addressUrlList,
      id,
      fileList,
      message,
      longitude,
      latitude
    ) {
      this.materialList = this.materialList.map((item) => {
        if (item.id === id) {
          item.status = true;
          if (message.length > 0 && fileList.length > 0) {
            item.content = {
              pic: addressUrlList.map(e => {
                console.log(e)
                return {url: e}
              }),
              url: addressUrlList,
              longitude: longitude,
              latitude: latitude,
              desc: message,
            }
          } else {
            Toast.fail('请输入详细地址和图片信息');
          }
        }
        return item;
      });
    },

    //上传提交
    submit() {
      let params
      if (this.$route.params.object) {
        const id = this.$route.params.object.id
        console.log('当前参数为', this.$route.params.object);
        this.getCurrentDate();
        this.parameter();
        this.material.id = id;
        params = this.material;
        console.log(params);
        uploadPosApplyDetail(params).then((res) => {
          console.log("提交响应拦截返回修改后的数据", res);
          if (res.data.addressText.length > 0 && res.data.addressUrl.length > 0) {
            alert("修改成功");
            this.$router.push("/material_declarationList");
          }
        })
      } else {
        this.getCurrentDate();
        this.parameter();
        params = this.material;
        console.log(params);
        if (this.material.addressText && this.material.addressUrl) {
          uploadPosApplyDetail(params).then((res) => {
            console.log("提交响应拦截", res);
            if (res.data.addressText.length > 0 && res.data.addressUrl.length > 0) {
              alert("上传成功");
              this.$router.push("/material_declarationList");
            }
          });
        } else {
          Toast.fail('上传失败，请输入详细地址信息和图片信息');
        }

      }
    },

    //遍历参数列表
    parameter() {
      for (let i of this.materialList) {
        // console.log(i);
        if (i.name == "front") {
          this.material.frontUrl = JSON.stringify(i.content.url);
          this.material.frontText = i.content.desc;
        }
        if (i.name == "side") {
          this.material.sideUrl = JSON.stringify(i.content.url);
          this.material.sideText = i.content.desc;
        }
        if (i.name == "offside") {
          this.material.offsideUrl = JSON.stringify(i.content.url);
          this.material.offsideText = i.content.desc;
        }
        if (i.name == "behind") {
          this.material.behindUrl = JSON.stringify(i.content.url);
          this.material.behindText = i.content.desc;
        }
        if (i.name == "down") {
          this.material.downUrl = JSON.stringify(i.content.url);
          this.material.downText = i.content.desc;
        }
        if (i.name == "around") {
          this.material.aroundUrl = JSON.stringify(i.content.url);
          this.material.aroundText = i.content.desc;
        }
        if (i.name == "opening_hours") {
          this.material.openingHoursUrl = JSON.stringify(i.content.url);
          this.material.openingHoursText = i.content.desc;
        }
        if (i.name == "telephone") {
          this.material.telephoneUrl = JSON.stringify(i.content.url);
          this.material.telephoneText = i.content.desc;
        }
        if (i.name == "price") {
          this.material.priceUrl = JSON.stringify(i.content.url);
          this.material.priceText = i.content.desc;
        }
        if (i.name == "rule") {
          this.material.ruleUrl = JSON.stringify(i.content.url);
          this.material.ruleText = i.content.desc;
        }
        if (i.name == "guide") {
          this.material.guideUrl = JSON.stringify(i.content.url);
          this.material.guideText = i.content.desc;
        }
        if (i.name == "synopsis") {
          this.material.synopsisUrl = JSON.stringify(i.content.url);
          this.material.synopsisText = i.content.desc;
        }
        if (i.name == "lon") {
          this.material.addressUrl = JSON.stringify(i.content.url);
          this.material.addressText = i.content.desc;
          this.material.longitude = i.content.longitude;
          this.material.latitude = i.content.latitude;
        }
        if (i.name == "logon_qrcode") {
          this.material.logonQrcodeUrl = JSON.stringify(i.content.url);
          this.material.logonQrcodeText = i.content.desc;
        }
        if (i.name == "start_qrcode") {
          this.material.startQrcodeUrl = JSON.stringify(i.content.url);
          this.material.startQrcodeText = i.content.desc;
        }
      }
    },
  },
};
</script>

<style scoped>

h1 {
  text-align: center;
}

.home {
  display: flex;
  flex-flow: column;
  height: 100%;
  font-size: 12px;
}

.content {
  float: left;
  margin-bottom: 10px;
}

.vng {
  text-align: center;
}

.ipt {
  width: 336px;
  height: 24px;

}

.icon {
  width: 40px;
  height: 40px;
  margin: 10px;
}

.van-grid {
  width: 100%;
  position: relative;
}

img {
  position: absolute;
  width: 90%;
  height: 80%;
  top: auto;
  left: 6px;
  object-fit: cover; /* 填充整个容器 */
}

.button {
  border-radius: 5px;
  margin: 5px 0;
}

.pass {
  width: 80px;
  height: 35px;
  background: #409EFF;
  color: white;
  border: 0;
}

.reject {
  width: 80px;
  height: 35px;
  background: #F56C6C;
  color: white;
  border: 0;
}

.send {
  width: 80px;
  height: 35px;
  background: #f5de6c;
  color: white;
  border: 0;
}


/*.w-100 {
  width: 100%;
  height: 80%;
}

.h-100 {
  width: 80%;
  height: 100%;
}*/
</style>



// WEBPACK FOOTER //
// src/views/material_collection.vue